import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueClipBoard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css'
import NProgress from 'nprogress' // 进度条；
import 'nprogress/nprogress.css' // 进度条样式
import '@/css/layout.scss'
import '@/js/lib-flexible'
import { getUserPageInfo } from '@/api/setting/member'
import msg from '@/utils/message'
import format from '@/utils/format'
import config from '@/utils/config'
import { filterAsyncRouter } from '@/utils/asyncRoute'
import elDragDialog from './js/directive/el-dragDialog'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import * as echarts from 'echarts'
import BaiduMap from 'vue-baidu-map'

Vue.prototype.$echarts = echarts
Vue.directive('dragDialog', elDragDialog)
Vue.use(ElementUI)

 
Vue.use(BaiduMap, {
  ak: 'dAVCgTnW50hRWsp1bXRfPLPIMLF1nR3b'
})

Vue.use(VueClipBoard)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
})

Vue.config.productionTip = false
const whiteList = ['/login'] // 白名单，可直接访问;
NProgress.configure({
  showSpinner: false,
}) // 进度配置;
router.beforeEach((to, from, next) => {
  NProgress.start() // 开始显示进度条
  var token = localStorage.getItem('X-Token')
  /** ********************/
  if (token) {
    if (to.path === '/login') {
      next({
        path: '/',
      })
      NProgress.done() // 结束进度条
    } else {
      if (store.state.route.routers.length <= 0) {
        getUserPageInfo().then((r) => {
          let base_router = JSON.stringify(r);
          const filterAsyncRouters = filterAsyncRouter(JSON.parse(base_router))
          store.commit('routers', filterAsyncRouters)
          localStorage.setItem('X-routes', JSON.stringify(base_router))
          router.addRoutes(filterAsyncRouters)
        })
        next()
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next('/login') // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

Vue.prototype.format = format
Vue.prototype.config = config
Vue.prototype.msg = msg


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
